import {useMemo} from 'react';
import ReactGoogleRecaptcha, {ReCAPTCHAProps} from 'react-google-recaptcha';

import {envConfig} from 'config';
import {LanguageService} from 'services';

type Props = Omit<ReCAPTCHAProps, 'sitekey'>

export const NotRobotCaptcha: React.FC<Props> = (props: Props) => {
    const language = useMemo(() => LanguageService.getLanguage(), []);

    return (
        <ReactGoogleRecaptcha
            sitekey={envConfig.googleCaptchaSiteKey}
            hl={language}
            {...props}
        />
    );
};
